/**
 * DEV-PILOT SUBSET of main's revenueCatService (#559-pattern surgical
 * cherry-pick): only the Capacitor runtime check Drive Mode imports. The full
 * service (RevenueCat configure/purchase, `@revenuecat/purchases-capacitor`
 * dynamic import) stays on main — bringing it here would add the capacitor
 * packages to develop's dependency tree, which the pilot deliberately avoids.
 * The next real main→develop sync REPLACES this file with main's full version
 * (a content conflict here is expected and resolves to main). Function bodies
 * are verbatim from main — do not edit them independently.
 */

const getDefaultCapacitorRuntime = () => {
    if (typeof window === 'undefined') {
        return undefined;
    }

    return window.Capacitor;
};

export const isNativeCapacitorRuntime = (capacitorRuntime = getDefaultCapacitorRuntime()) => (
    Boolean(capacitorRuntime?.isNativePlatform?.())
);
